export default {
      id: "youtube-usage",
      viewBox: "0 0 18 13",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#youtube-usage",
      toString: function () {
        return this.url;
      }
    }